import React, { FC } from 'react'

import { ButtonStyled, TButtonColor } from './index.style'

interface IPropertiesButton {
    children: React.ReactNode
    circle?: boolean
    fullWidth?: boolean
    onClick?: () => void
    color?: TButtonColor
}

export const Button: FC<IPropertiesButton> = properties => {
    return (
        <ButtonStyled
            circle={properties.circle}
            fullWidth={properties.fullWidth}
            color={properties.color || 'primary'}
            onClick={properties.onClick}
        >
            {properties.children}
        </ButtonStyled>
    )
}
